// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__33BBK","obliqueLineWrap":"membershipbadge_obliqueLineWrap__BeO8n","obliqueLine":"membershipbadge_obliqueLine__3kl2F"};